import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";

import styles from "../../styles/patient-page-modules/Summary.module.css";
import Spinner from "../../components/spinner";
import toast from "react-hot-toast";
import { BASE_URL_ML } from "../../utils/constants";
import axios from "axios";
import StreamingText from "../streamingText";

const Summary = ({loading=false, summary=''}) => {

  // const [summary, setSummary] = useState('');
  // const [loading, setLoading] = useState(false);

  // const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const patient_id = searchParams.get("patient_id");

  // const schema_name = sessionStorage.getItem("schema_name");

  // useEffect(() => {
  //   const fetchSummary = async () => {

  //     const url = `${BASE_URL_ML}/chatbot/summary?db_schema=${schema_name}&patient_id=${patient_id}&patient_type=RPM`;
  //     const mlFormData = new FormData();

  //     try {
  //       setLoading(true);
  //       const response = await axios.get(url, mlFormData);
  //       setSummary(response.data.summary);
  //       toast.success("Summary Generated...!");
  //     } catch (error) {
  //       if (!error.response) {
  //         toast.error("Network error. Please check your internet connection.");
  //       } else if (error.response.status === 404) {
  //         toast.error("An error occurred during summary generation.");
  //       } else {
  //         toast.error(
  //           `An unexpected error occurred: ${error.response.statusText || "Unknown error"
  //           }`
  //         );
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchSummary()

  // }, []);

  return (
    <>
      {loading ? (
        <div className={styles.summary_loader}>
          <div className={styles.summary_loader_spinner}>
            <Spinner scale={7} />
          </div>
          <p className={styles.summary_loader_text}>Toca CoPilot is Generating Summary...</p>
        </div>
      ) : (
        <StreamingText
          text={summary ? summary : "No summary available."}
          className={styles.summary_text}
        />
      )}
    </>
  );
};

export default Summary;
